import { useQuery } from 'react-query';

import { GqlRequestOptions } from '@common/api-request';
import { checkValidCatalogProductId, queryOptions } from '@domains/pdp-common';

import { getUserBenefitInfo } from '../graphql/user-benefit-info.2';

export interface GetUserBenefitInfoParam {
  catalog_product_id: string;
  final_price: number | null;
  withMembership: boolean;
}
export function getUserBenefitInfoQueryOption(param: GetUserBenefitInfoParam, options?: GqlRequestOptions) {
  return {
    queryKey: ['getUserBenefitInfo', param.final_price, Boolean(param.withMembership)],
    queryFn: async function () {
      const { data } = await getUserBenefitInfo(
        {
          input: {
            catalog_product_id: param.catalog_product_id,
            final_price: param.final_price,
          },
          withMembership: Boolean(param.withMembership),
        },
        { ...options, show_alert: false },
      );

      return data.pdp_user_base_info;
    },
    ...queryOptions,
    enabled: checkValidCatalogProductId(param.catalog_product_id) && Number.isInteger(param.final_price),
  };
}

export function useUserBenefitInfoQuery(param: GetUserBenefitInfoParam, options?: GqlRequestOptions) {
  const DEFAULT_DATA = {
    pdp_max_user_benefit: null,
    pdp_user_membership: null,
    pdp_user_additional_mileage: null,
    pdp_user_nonmember_membership: null,
  };
  const response = useQuery(getUserBenefitInfoQueryOption(param, options));
  return {
    ...response,
    pdp_user_base_info: response.error || !response.data ? DEFAULT_DATA : response.data,
  };
}
